import { makeStyles } from '@mui/styles';

export const muiStyles = makeStyles(() => {
    return {
        lfSelectContainer: { width: '240px' },
        seeDetailsButtonContainer: {
            display: 'flex' as const,
            justifyContent: 'flex-start' as const,
            width: '100%',
            backgroundColor: '#B9D9EC',
            padding: '6px 0',
            borderRadius: '0 0 4px 4px'
        },
        seeDetailsButton: {
            cursor: 'pointer' as const,
            color: '#3C4F70',
            paddingLeft: '12px'
        },
        noBorderCell: { borderBottom: 'none' as const },
        feeDetailsHeader: { fontWeight: 'bold' as const },
        feeType: { textTransform: 'capitalize' as const },
        'good-standing': { color: '#5AAC01' },
        'bad-standing': { color: '#EA3323' }
    };
});